import { useState } from "react";
const BASE = "https://imalishawelfare.com/api";
const tok = () => sessionStorage.getItem("token");

export default function ManualSTK() {
  const [phone, setPhone] = useState("");
  const [amount, setAmount] = useState("");
  const [desc, setDesc] = useState("Loan Processing Fee");
  const [ref, setRef] = useState("");
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");

  const fmt = n => "KSh " + Number(n||0).toLocaleString("en-KE");

  const send = async () => {
    setError(""); setResult(null);
    if (!phone || phone.length < 10) { setError("Enter a valid 10-digit phone number"); return; }
    if (!amount || Number(amount) < 1) { setError("Enter a valid amount"); return; }
    if (!window.confirm(`Send M-Pesa STK push to ${phone} for ${fmt(amount)}?`)) return;
    setLoading(true);
    try {
      const formattedPhone = phone.startsWith("0") ? "254" + phone.substring(1) : phone;
      const refCode = ref || ("ADM-" + Date.now().toString().slice(-8));
      const r = await fetch(`${BASE}/loans/manual-stk`, {
        method: "POST",
        headers: { Authorization: "Bearer " + tok(), "Content-Type": "application/json" },
        body: JSON.stringify({ phone: formattedPhone, amount: Number(amount), description: desc, reference: refCode })
      });
      const data = await r.json();
      if (r.ok) {
        setResult({ success: true, message: "STK push sent to " + phone, data });
        setPhone(""); setAmount(""); setRef("");
      } else {
        setError(data.message || data.errorMessage || "Failed to send STK push");
      }
    } catch(e) { setError("Error: " + e.message); }
    setLoading(false);
  };

  return (
    <div style={{ maxWidth:520, margin:"0 auto", fontFamily:"-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif" }}>
      <div style={{ background:"white", borderRadius:14, padding:32, boxShadow:"0 2px 12px rgba(0,0,0,0.08)" }}>

        {/* Header */}
        <div style={{ display:"flex", alignItems:"center", gap:14, marginBottom:28 }}>
          <div style={{ width:48, height:48, background:"linear-gradient(135deg,#0052a3,#003d7a)", borderRadius:12, display:"flex", alignItems:"center", justifyContent:"center" }}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2"><rect x="5" y="2" width="14" height="20" rx="2"/><line x1="12" y1="18" x2="12.01" y2="18"/></svg>
          </div>
          <div>
            <h2 style={{ fontSize:18, fontWeight:700, color:"#1e293b", margin:0 }}>Manual STK Push</h2>
            <p style={{ fontSize:13, color:"#64748b", margin:0 }}>Send M-Pesa payment prompt to any number</p>
          </div>
        </div>

        {/* Phone */}
        <div style={{ marginBottom:16 }}>
          <label style={{ display:"block", fontSize:11, fontWeight:700, color:"#64748b", marginBottom:6, textTransform:"uppercase", letterSpacing:.5 }}>Phone Number *</label>
          <input
            value={phone}
            onChange={e => setPhone(e.target.value.replace(/\D/g,""))}
            maxLength={10}
            placeholder="0712345678"
            style={{ width:"100%", padding:"12px 14px", border:"1.5px solid #e2e8f0", borderRadius:8, fontSize:15, fontWeight:600, boxSizing:"border-box", fontFamily:"monospace" }}
          />
          <p style={{ fontSize:11, color:"#94a3b8", margin:"4px 0 0" }}>Kenyan number starting with 07 or 01</p>
        </div>

        {/* Amount */}
        <div style={{ marginBottom:16 }}>
          <label style={{ display:"block", fontSize:11, fontWeight:700, color:"#64748b", marginBottom:6, textTransform:"uppercase", letterSpacing:.5 }}>Amount (KSh) *</label>
          <div style={{ position:"relative" }}>
            <span style={{ position:"absolute", left:14, top:"50%", transform:"translateY(-50%)", fontSize:13, fontWeight:700, color:"#64748b" }}>KSh</span>
            <input
              type="number"
              value={amount}
              onChange={e => setAmount(e.target.value)}
              placeholder="Enter amount"
              min={1}
              style={{ width:"100%", padding:"12px 14px 12px 52px", border:"1.5px solid #e2e8f0", borderRadius:8, fontSize:15, fontWeight:700, boxSizing:"border-box" }}
            />
          </div>
          {amount && <p style={{ fontSize:12, color:"#10b981", margin:"4px 0 0", fontWeight:700 }}>{fmt(amount)}</p>}
        </div>

        {/* Description */}
        <div style={{ marginBottom:16 }}>
          <label style={{ display:"block", fontSize:11, fontWeight:700, color:"#64748b", marginBottom:6, textTransform:"uppercase", letterSpacing:.5 }}>Description</label>
          <select value={desc} onChange={e => setDesc(e.target.value)}
            style={{ width:"100%", padding:"12px 14px", border:"1.5px solid #e2e8f0", borderRadius:8, fontSize:14, boxSizing:"border-box" }}>
            <option>Loan Processing Fee</option>
            <option>Loan Disbursement</option>
            <option>Registration Fee</option>
            <option>Document Fee</option>
            <option>Other Payment</option>
          </select>
        </div>

        {/* Reference */}
        <div style={{ marginBottom:24 }}>
          <label style={{ display:"block", fontSize:11, fontWeight:700, color:"#64748b", marginBottom:6, textTransform:"uppercase", letterSpacing:.5 }}>Reference (Optional)</label>
          <input
            value={ref}
            onChange={e => setRef(e.target.value)}
            placeholder="e.g. APP-001 or leave blank for auto"
            style={{ width:"100%", padding:"12px 14px", border:"1.5px solid #e2e8f0", borderRadius:8, fontSize:14, boxSizing:"border-box" }}
          />
        </div>

        {/* Preview box */}
        {phone && amount && (
          <div style={{ background:"#f8fafc", border:"1.5px solid #e2e8f0", borderRadius:10, padding:16, marginBottom:20 }}>
            <p style={{ fontSize:11, fontWeight:700, color:"#64748b", margin:"0 0 10px", textTransform:"uppercase", letterSpacing:.5 }}>Preview</p>
            {[["Phone",phone],["Amount",fmt(amount)],["Description",desc],["Reference",ref||"Auto-generated"]].map(([k,v])=>(
              <div key={k} style={{ display:"flex", justifyContent:"space-between", padding:"6px 0", borderBottom:"1px solid #f1f5f9", fontSize:13 }}>
                <span style={{ color:"#64748b" }}>{k}</span>
                <span style={{ fontWeight:600, color:"#1e293b" }}>{v}</span>
              </div>
            ))}
          </div>
        )}

        {/* Error */}
        {error && (
          <div style={{ background:"#fee2e2", border:"1px solid #fca5a5", borderRadius:8, padding:"10px 14px", marginBottom:16, fontSize:13, color:"#7f1d1d", fontWeight:500 }}>
            {error}
          </div>
        )}

        {/* Success */}
        {result?.success && (
          <div style={{ background:"#f0fdf4", border:"1px solid #86efac", borderRadius:8, padding:"14px 16px", marginBottom:16, display:"flex", alignItems:"center", gap:10 }}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#10b981" strokeWidth="2.5"><polyline points="20 6 9 17 4 12"/></svg>
            <div>
              <p style={{ fontSize:13, fontWeight:700, color:"#166534", margin:0 }}>{result.message}</p>
              <p style={{ fontSize:12, color:"#166534", margin:"2px 0 0", opacity:.8 }}>Ask the recipient to enter their M-Pesa PIN to complete payment.</p>
            </div>
          </div>
        )}

        {/* Button */}
        <button onClick={send} disabled={loading}
          style={{ width:"100%", padding:14, background:loading?"#94a3b8":"linear-gradient(135deg,#10b981,#059669)", color:"white", border:"none", borderRadius:10, fontWeight:700, fontSize:15, cursor:loading?"not-allowed":"pointer", display:"flex", alignItems:"center", justifyContent:"center", gap:10, transition:"all 0.2s" }}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2"><rect x="5" y="2" width="14" height="20" rx="2"/><line x1="12" y1="18" x2="12.01" y2="18"/></svg>
          {loading ? "Sending STK Push..." : `Send KSh ${amount ? Number(amount).toLocaleString() : "0"} Prompt`}
        </button>

        <p style={{ fontSize:11, color:"#94a3b8", textAlign:"center", margin:"12px 0 0" }}>
          Powered by Safaricom Daraja API · Shortcode 4010685
        </p>
      </div>
    </div>
  );
}

